import { sdkRequest } from '@eb/http';
import { useQuery, useQueryClient } from 'react-query';
import { User } from '../types';

const FIVE_MINUTES = 5 * 60 * 1000;

export const getUser = async (): Promise<User> => {
    const user = await sdkRequest('/api/v3/users/me/');
    return user;
};

interface UseUserResponse {
    fetchUserData: Function;
    id?: string;
    firstName?: string;
    lastName?: string;
    name?: string;
}

export const useUser = (): UseUserResponse => {
    const queryClient = useQueryClient();

    //Get user object to grab logged in user ID if not passed through
    const { data: userObject, refetch: fetchUser } = useQuery('user', getUser, {
        enabled: false,
        retry: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        staleTime: FIVE_MINUTES,
    });

    const userId = userObject?.id;

    const fetchUserData = (user?: User) => {
        if (user && !userId) {
            //Imperatively set the cache data since we have the user object
            //via props passed to the event card
            queryClient.setQueryData('user', user);
        } else if (!userId) {
            return fetchUser();
        }

        return Promise.resolve();
    };

    return {
        fetchUserData,
        id: userId,
        firstName: userObject?.first_name,
        lastName: userObject?.last_name,
        name: userObject?.name,
    };
};
